<div class="greetings-container">
  <div class="greetings">
    {{getGreeting() | translate }},
  </div>
  <div class="name">{{authService.user()?.first_name}}</div>
  <div class="question">{{'greetings.feeling' | translate}}</div>
  
  <div matRipple class="logo-container" (click)="goToFeeling()">
    <img src="/imgs/all.png" alt="logo image" class="logo">
  </div>
</div>

@if(authService.user()?.profile === PROFILES.ADMIN.key) {
  <app-approve-psychologist></app-approve-psychologist>
}

@if(authService.user()?.profile === PROFILES.PSYCHOLOGIST.key) {
  <app-approve-user-connnection></app-approve-user-connnection>
}

@if(!loading() || !loadingAcceptingInvite()){
  @if(
    !userPsychologist()
    && originalState.psychologist_connection
    && authService.user()?.profile !== PROFILES.PSYCHOLOGIST.key
  ){
    <app-message-alert></app-message-alert>
  }
}

@if (originalState.notifications) {
  @if(configService.getNotificationStatus() === NOTIFICATION_STATUS.DEFAULT){
    <app-request-notifications></app-request-notifications>
  }
}

@if(authService.user()?.profile !== PROFILES.PSYCHOLOGIST.key) {
  <app-confirm-appointment></app-confirm-appointment>
}

